import React from 'react';
import { Header } from './components/common/Header';
import { PdfViewer } from './components/pdf/PdfViewer';
import { UploadZone } from './components/takeoff/UploadZone';
import { MaterialTotals } from './components/takeoff/MaterialTotals';
import { DrawnWireTotals } from './components/takeoff/DrawnWireTotals';
import { WireScheduleList } from './components/takeoff/WireScheduleList';
import { EquipmentCards } from './components/takeoff/EquipmentCards';
import { FusesBreakers } from './components/takeoff/FusesBreakers';
import { DrawnStringsList } from './components/takeoff/DrawnStringsList';
import { ActionBar } from './components/takeoff/ActionBar';
import { DebugTables } from './components/takeoff/DebugTables';
import { HistoryDrawer } from './components/history/HistoryDrawer';
import { LoginPage } from './components/auth/LoginPage';
import { MaterialListManager } from './components/materials/MaterialListManager';
import { useAuth } from './context/AuthContext';
import { useApp } from './context/AppContext';

export const MainApp: React.FC = () => {
  const { session, loading } = useAuth();
  const { singleViewMode, activeView } = useApp();

  if (loading) {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '16px',
        }}
      >
        <div className="spinner" style={{ width: '36px', height: '36px' }} />
        <p style={{ color: 'var(--text-muted)', fontSize: '0.95rem' }}>
          Checking secure session...
        </p>
      </div>
    );
  }

  if (!session?.authenticated) {
    return <LoginPage />;
  }

  return (
    <>
      <Header />

      {activeView === 'MATERIAL_LIST' && <MaterialListManager />}

      {activeView === 'TAKEOFF' && (
        <main className={`main-wrapper ${singleViewMode ? 'single-view-mode' : ''}`}>
          {/* Left Panel: Interactive PDF and Measurement Canvas */}
          <PdfViewer />

          {/* Right Panel: Extraction Results, Takeoffs, and Controls */}
          <section className="right-panel">
            <div style={{ maxWidth: '100%' }}>
              <h1>Plan Extractor</h1>
              <p className="subtitle">Upload your Electrical Plan PDF</p>

              <UploadZone />
              <MaterialTotals />
              <DrawnWireTotals />
              <WireScheduleList />
              <EquipmentCards />
              <FusesBreakers />
              <DrawnStringsList />
              <ActionBar />
              <DebugTables />
            </div>
          </section>
        </main>
      )}

      <HistoryDrawer />
    </>
  );
};

